import NewsletterEmail from 'Models/NewsletterEmail';
import { MODULE_NEWSLETTER_EMAILS } from 'Lib/enums/ApiModules';

export const MODULES_MAP = {
  [MODULE_NEWSLETTER_EMAILS]: {
    model: NewsletterEmail,
    title: 'Newsletter Email',
  },
};
